'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import BreakdownScoreContainer from '../BreakdownScoreContainer';
import ResultSection from '../result/ResultSection';
import RadialProgressBar from '../RadialProgressBar';
import OverallData from '../../data/components/OverallData';
import OverallResultSection from '../result/OverallResultSection';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { MON109_CMS_DTT_LINK, STARTER_LINK } from '../../constants/TrialConstants';
import usageTracker from '../../lib/usageTracker';
import { parseUtmParams } from '../../util/Urls';
import { useTreatment, TREATMENT_KEY_CGFE_005 } from '../../hooks/useTreatments';

var handleTrialCTAClick = function handleTrialCTAClick(_ref) {
  var websiteUrl = _ref.websiteUrl;
  usageTracker.log('trialBannerClick', {
    type: 'dtt-cta-click',
    websiteUrl: websiteUrl,
    source: 'trial-cta-sidepanel'
  });
};

var handleStarterCTAClick = function handleStarterCTAClick(_ref2) {
  var websiteUrl = _ref2.websiteUrl;
  usageTracker.log('starterCtaClick', {
    type: 'dts-cta-click',
    websiteUrl: websiteUrl,
    source: 'trial-cta-sidepanel'
  });
};

var NoCreditCard = function NoCreditCard() {
  return /*#__PURE__*/_jsx("span", {
    className: "no-credit-card",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "results.sidePanel.overallGrade.cta.noCreditCard"
    })
  });
};

var BuyStarterCTA = function BuyStarterCTA(_ref3) {
  var onClick = _ref3.onClick;
  var parsedUtmParams = parseUtmParams();
  return /*#__PURE__*/_jsx("a", {
    className: "button white",
    target: "_blank",
    rel: "noopener noreferrer",
    href: STARTER_LINK + "&" + parsedUtmParams,
    onClick: onClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "trialBanner.ctaStarterButton"
    })
  });
};

var TrialCTA = function TrialCTA(_ref4) {
  var onClick = _ref4.onClick;
  var parsedUtmParams = parseUtmParams();
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("a", {
      className: "button white",
      target: "_blank",
      rel: "noopener noreferrer",
      href: MON109_CMS_DTT_LINK + "&" + parsedUtmParams,
      onClick: onClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "trialBanner.ctaButton"
      })
    }), /*#__PURE__*/_jsx(NoCreditCard, {})]
  });
};

var CTAExperiment = function CTAExperiment(_ref5) {
  var websiteUrl = _ref5.websiteUrl;
  var treatment = useTreatment(TREATMENT_KEY_CGFE_005);

  if (!treatment.parameters) {
    return null;
  }

  if (treatment.parameters.ctaopt === 'starter') {
    return /*#__PURE__*/_jsx(BuyStarterCTA, {
      onClick: function onClick() {
        return handleStarterCTAClick({
          websiteUrl: websiteUrl
        });
      }
    });
  }

  return /*#__PURE__*/_jsx(TrialCTA, {
    onClick: function onClick() {
      return handleTrialCTAClick({
        websiteUrl: websiteUrl
      });
    }
  });
};

var CTABottom = function CTABottom(_ref6) {
  var websiteUrl = _ref6.websiteUrl;
  return /*#__PURE__*/_jsxs("div", {
    className: "cta-section",
    children: [/*#__PURE__*/_jsx("div", {
      className: "cta-title",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "results.sidePanel.overallGrade.cta.title"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "cta-microcopy",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "results.sidePanel.overallGrade.cta.microcopy"
      })
    }), /*#__PURE__*/_jsx(CTAExperiment, {
      websiteUrl: websiteUrl
    })]
  });
};

export default (function (_ref7) {
  var websiteGrade = _ref7.websiteGrade,
      _ref7$hideCTAs = _ref7.hideCTAs,
      hideCTAs = _ref7$hideCTAs === void 0 ? false : _ref7$hideCTAs;
  var url = websiteGrade.domain;
  var grade = websiteGrade.overallGrade;
  var overallData = new OverallData().init(grade);
  var gradeType = overallData.gradeType;
  return /*#__PURE__*/_jsx("div", {
    className: "sidepanel-overall-grade",
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs(ResultSection, {
        gradeType: gradeType,
        children: [/*#__PURE__*/_jsx(RadialProgressBar, {
          score: grade,
          children: grade
        }), /*#__PURE__*/_jsx("div", {
          className: "website-url",
          children: url
        }), /*#__PURE__*/_jsx("div", {
          className: "side-panel-result-section",
          children: /*#__PURE__*/_jsx(OverallResultSection, {
            websiteGrade: websiteGrade
          })
        }), /*#__PURE__*/_jsx(BreakdownScoreContainer, {
          websiteGrade: websiteGrade
        }), !hideCTAs && /*#__PURE__*/_jsx(CTABottom, {
          websiteUrl: url
        })]
      })
    })
  });
});